// components/Layout.js
import React from 'react';
import Sidebar from './Sidebar';
import LandingNavbar from './Landing/LandingNavbar';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();

  // List of routes where we do not need the Sidebar
  const authRoutes = ['/client-login', '/forgot-password', '/signup', '/verify-otp', '/reset-password', '/success'];

  // Check if current route is the landing page
  const isLandingPage = location.pathname === '/';

  // Check if the current route is one of the auth routes
  const isAuthRoute = authRoutes.includes(location.pathname);

  return (
    <div className="app-container">
      {isLandingPage && <LandingNavbar />}
      {!isAuthRoute && !isLandingPage && <Sidebar />}
      <main className={`main-content ${(!isAuthRoute && !isLandingPage) ? 'with-sidebar' : ''} ${isLandingPage ? 'landing-main' : ''}`}>
        {children}
      </main>
    </div>
  );
};


export default Layout;
